export default __webpack_public_path__ + "static/media/OpenSans-Regular.a5fe783d.ttf";